import { omitPathParameters, replacePathParameters } from "../../utils.ts";
import { type OperationResponse, type Parameters } from "../../common.ts";
import type { AxiosInstance, AxiosRequestConfig } from "axios";

import type * as Paths from "./paths";

interface OperationMethods {
  "getProducts"(
    parameters?: Parameters<
      Paths.GetProducts.PathParameters & Paths.GetProducts.QueryParameters
    >,
    data?: null,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.GetProducts.Responses.$200>;

  "manageProducts"(
    parameters: Parameters<
      Paths.ManageProducts.QueryParameters & Paths.ManageProducts.PathParameters
    >,
    data: Paths.ManageProducts.RequestBody,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.ManageProducts.Responses.$200>;

  "syncProducts"(
    parameters?: Parameters<Paths.SyncProducts.PathParameters> | null,
    data?: Paths.SyncProducts.RequestBody,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.SyncProducts.Responses.$200>;
}

export const getManufacturerOperations = (client: AxiosInstance) => {
  const syncProducts: OperationMethods["syncProducts"] = // todo remove?
    (parameters, data, config) => {
      const url = "/manufacturer/sync-products/{id}";
      return client.put(replacePathParameters(url, parameters), data, {
        params: omitPathParameters(parameters, url),
        ...config,
      });
    };

  const getProducts: OperationMethods["getProducts"] = (
    parameters,
    _,
    config,
  ) => {
    const url = "/manufacturer/{id}/products";
    return client.get(replacePathParameters(url, parameters), {
      params: omitPathParameters(parameters, url),
      ...config,
    });
  };

  const manageProducts: OperationMethods["manageProducts"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/manufacturer/{id}/products/manage";
    return client.patch(replacePathParameters(url, parameters), data, {
      params: omitPathParameters(parameters, url),
      ...config,
    });
  };

  return {
    getProducts,
    syncProducts,
    manageProducts,
  };
};
